<template>
  <div :class="`addCard ${addIsUser ? 'addIsUser' : ''}`">
    <mobileBack :otherClick="true" @backOtherClick="back" v-if="(showTopBack || addIsUser) && personals.length" class="mobileBackBg"></mobileBack>
    <div v-if="addIsUser" class="title">个人信息</div>
    <div class="itemCard">
      <div v-if="!personals.length && !isTeam">请完善个人信息</div>
      <div class="lineContent">
        <div class="name" v-if="isTeam"><span style="letter-spacing: 0.2rem">负责</span>人:</div>
        <div class="name" v-else><span style="letter-spacing: 0.8rem">姓</span>名:</div>
        <el-input v-model="addDetail.personName" placeholder="请输入姓名" :disabled="addDetail.personNameDisabled || addDetail.haveOrder" oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
      </div>
      <!-- 参观人 -->
      <div v-if="addType == 'personal'">
        <div class="lineContent" v-if="!isTeam">
          <div class="name">证件类型:</div>
          <el-select v-model="addDetail.cardType" placeholder="请选择" :disabled="addDetail.haveOrder">
            <el-option
              v-for="item in cardTypes"
              :key="item.val"
              :label="item.name"
              :value="item.val">
            </el-option>
          </el-select>
        </div>
        <div v-else class="lineContent">
          <div class="name">团队名称:</div>
          <el-input v-model="addDetail.orgName" placeholder="请输入姓名" :disabled="addDetail.haveOrder"></el-input>
        </div>
        <div class="lineContent">
          <div class="name">{{isTeam ? '身份证号:' : '证件号码:'}}</div>
          <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码" :disabled="addDetail.haveOrder"></el-input>
        </div>
        <div class="lineContent">
          <div class="name">联系电话:</div>
          <el-input v-model="addDetail.phone" placeholder="请输入联系电话" type="number" oninput="if(value.length>11)value=value.slice(0,11)" :disabled="addDetail.phoneDisabled || addDetail.haveOrder"></el-input>
        </div>
      </div>
      <div v-if="addType != 'personal'">
        <div class="lineContent">
          <div class="name">年龄(岁):</div>
          <el-input v-model="addDetail.age" placeholder="请输入年龄" type="number" :disabled="addDetail.haveOrder"></el-input>
        </div>
        
        <div class="lineContent" v-if="$store.state.ticketDetail.childCardNumOn">
          <div class="name">身份证号:</div>
          <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码" :disabled="addDetail.haveOrder"></el-input>
        </div>
        <div class="lineContent">
          <div class="name">性别:</div>
          <el-radio-group v-model="addDetail.gender" :disabled="addDetail.haveOrder">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="tips" v-if="addDetail.haveOrder">该用户有过历史订单，暂不支持修改基本信息</div>
    </div>
    <div class="back" @click="back" v-if="personals.length && !showTopBack && !hideBottomBack">返回</div>
    <div class="buttonNormalContain" @click="saveAddPerson" v-if="!addDetail.haveOrder">确认提交</div>
    <!-- <h5Bottom v-if="!addIsUser && showBottomBtn"></h5Bottom> -->
    <h5Bottom v-if="!addIsUser"></h5Bottom>
  </div>
</template>

<script>
import mobileBack from '../common/mobileBack.vue'
import h5Bottom from '../common/h5Bottom.vue'
export default {
  data() {
    return {
      // detail: {
      //   name: '',
      //   cardType: '身份证',
      //   card: '',
      //   phone: ''
      // }
    };
  },

  props: ['cardTypes', 'addDetail', 'addType', 'personals', 'isTeam', 'showTopBack', 'hideBottomBack', 'addIsUser'],

  components: {mobileBack, h5Bottom},

  methods: {
    back() {
      this.$emit('handelShowAdd', false)
    },

    saveAddPerson() {
      // console.log(124)
      this.$debounce(this.$emit('saveAddPerson', this.addDetail),1000)
      
    },

    getDetailInfo() {
      if (this.addDetail.phone == this.$cookie.get('ticket_phone')) {
        this.addDetail.phoneDisabled = true
      }
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${this.addDetail.id}`).then((res) =>{
        res = res.data
        this.$emit('changeAddDetail', res)
      })
    }
  },

  mounted() {
    this.$nextTick(() =>{
      this.addDetail.id ? this.getDetailInfo() : ''
    })
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .addCard{
    position: absolute;
    top: 0;
    height: 100vh;
    width: 100%;
    background-color: #fff;
    z-index: 999;
    border-radius: 0.5rem;
    font-size: 0.4rem;
    line-height: 0.8rem;
    .cardImg{
      width: 5rem;
      height: 3rem;
      margin: auto;
      line-height: 2.5rem;
      font-size: 1rem;
      font-weight: 500;
      margin-top: 1rem;
      background: url('~@/assets/idCard.png') 0 0/100% no-repeat;
    }

    .tips{
      font-size: 0.36rem;
      text-align: left;
    }
    .back{
      position: fixed;
      bottom: 1.1rem;
      left: 0.8rem;
      line-height: 0.7rem;
      font-size: 0.4rem;
      border: 1px solid #726a6acc;
      padding: 0rem 0.3rem;
      border-radius: 0.2rem;
      color: #726a6acc;
    }
    .itemCard{
      position: relative;
      margin-bottom: 1rem;
      background-color: #fff;
      padding: 0.8rem 0.5rem!important;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
    }
    .buttonNormal{
      position: fixed;
      bottom: 1rem;
    }
    .lineContent .name{
      width: 2.5rem;
    }
    .cardName{
      text-align: left;
      width: 6.5rem;
      padding-left: 0.4rem;
    }
    .el-input{
      width: 6.5rem;
    }
    .lineContent{
      margin-bottom: 0.25rem;
    }
    .lineContentGary .cardName{
      color: #999999;
      background: #FBF8F2;
      border-radius: 0.156rem;
      line-height: 0.9rem;
      padding-left: 0.3rem;
      width: 6.2rem;
    }
    .buttonNormalContain{
      margin-top: 1.7rem;
    }
    .title{
      position: fixed;
      top: 0.4rem;
      left: 4rem;
      font-size: 0.5rem;
      letter-spacing: 1px;
    }
    .mobileBackBg{
      background: #FFFDFA;
      padding-bottom: 0.15rem;
      padding-top: 0.15rem;
      position: relative;
      &:after,&:before{
        position: absolute;
        content: '';
        display: inline-block;
        width: 1.1rem;
        height: 1.1rem;
        background: url('../../assets/ticket/taoyong.png') 0 0/contain no-repeat;
        opacity: 0.3;
      }
      &:after{
        left: 1.4rem;
        top: 0.25rem;
      }
      &:before{
        right: 1.3rem;
        top: 0.25rem;
        background: url('../../assets/ticket/taoyong1.png') 0 0/contain no-repeat;
      }
    }
  }
</style>
<style type="text/css">
  .addCard .lineContent .el-input__inner{
    width: 100%;
  }
  .addCard .lineContent input{
    border: 0.013rem solid #333333;
  }
  .addCard .el-radio-group{
    width: 6.5rem;
    text-align: left;
  }
  .addCard .el-input__inner{
    margin: 0.1rem 0;
    padding: 0 0.3rem;
    height: 1rem;
    background: #fff;
  }
  .addCard .el-input.is-disabled .el-input__inner{
    background: #FBF8F2;
    color: #999999;
    border: 0;
  }
  .noBelongData .addCard .itemCard{
    margin-top: 4rem;
  }
  .addCard .el-select{
    width: 6.5rem;
  }
  .addCard .el-icon-arrow-up:before{
    content: '';
    width: 0.3rem;
    height: 0.3rem;
    display: inline-block;
    transform: rotateZ(90deg);
    background: url('../../assets/ticket/arrow-left-filling.png') 0 0/ 100% 100% no-repeat;
  }
  .addCard .el-select .el-input__inner{
    border-color: #333333 !important;
  }
</style>

